import { Directive, HostListener, Input } from '@angular/core';
import { FileItem } from '../models';
import { LinkCopyService } from '../services/link-copy.service';

@Directive({
  selector: '[appCopyLink]',
})
export class CopyLinkDirective {
  @Input('appCopyLink') public rowData: FileItem;

  @HostListener('click', ['$event'])
  public async onClick(event: MouseEvent): Promise<void> {
    event.stopPropagation();
    await this.linkCopyService.copyLink(this.rowData);
  }

  constructor(private linkCopyService: LinkCopyService) {}
}
